<template>
  <div class="page-column">
    <Header :type="true"/>
    <div class="content-warp content-top">
      <div style="text-align: center;margin-bottom: 20px;">
        <h3 v-if="data.length === 0" style="color: red;">您还没有提交过裁判员信息</h3>
        <a-button type="primary" @click="$refs.editReferee.show(null)">
          添加裁判员 
        </a-button>
      </div>
      <div>
        <a-table :columns="columns" rowKey="id" :data-source="data" :pagination="false">
          <span slot="image" slot-scope="text, record">
            <img :src="text" style="width: 50px;"/>
          </span>
          <span slot="sex" slot-scope="text, record">
            <a-tag v-if="text === 1" color="blue">男</a-tag>
            <a-tag v-else color="pink">女</a-tag>
          </span>
          <template slot="refereeLevel" slot-scope="text, record">
            <div v-if="record.sportsLevel" style="margin-bottom: 5px;"><a-tag color="blue">竞技{{ record.sportsLevel }}</a-tag></div>
            <div v-if="record.poomsaeLevel"><a-tag color="blue">品势{{ record.poomsaeLevel }}</a-tag></div>
          </template>
          <template slot="status" slot-scope="text, record">
            <a-tag v-if="text === 0">未审核</a-tag>
            <a-tag v-if="text === 1" color="#87d068">通过</a-tag>
            <a-tag v-if="text === 2" color="#f50">不通过【驳回信息：{{ record.msg }}】</a-tag>
          </template>
          <template slot="isSelect" slot-scope="text, record">
            <div v-if="text == null">
              您还没有提交本次比赛执裁申请
              <a-button type="primary" @click="$refs.editReferee.show(record)">
                提交申请 
              </a-button>
            </div>
            <div v-else>
              <a-tag v-if="text === 0">未选调</a-tag>
              <a-tag v-if="text === 1" color="#87d068">选调</a-tag>
              <span v-if="text === 1 && matchInfo.refereeImg">入群二维码<a target="_blank" :href="matchInfo.refereeImg"><img style="width: 50px;height: 50px;" :src="matchInfo.refereeImg"/></a></span>
            </div>
          </template>
          <span slot="action" slot-scope="text, record">
            <a-button type="dashed" @click="$refs.editReferee.show(record)" size="small">
              编辑
            </a-button>
            <a-popconfirm
              title="确定要删除吗?"
              @confirm="() => delReferee(record)"
            >
              <a-button type="danger" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </span>
        </a-table>
      </div>
      <EditReferee ref="editReferee" @ok="findData"/>
      <a-modal
        title="公告"
        :visible="visible"
        @cancel="handleCancel"
        :footer="null"
      >
        <p class="markdown-body" v-html="notice"></p>
      </a-modal>
      <link :href="css" rel="stylesheet" type="text/html">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Header from '../../layout/Header.vue'
import EditReferee from './modal/EditReferee'
export default {
  name: 'matchReferee',
  components: {
    Header,
    EditReferee
  },
  computed: {
    ...mapState({
      matchInfo: (state) => state.match.matchInfo
    }),
  },
  data () {
    return {
      matchId: Number(this.$route.query.matchId),
      css: require('@comm/assets/css/github-markdown.min.css'),
      visible: false,
      notice: '',
      columns: [
        {
          title: '头像',
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
        },
        {
          title: '姓名',
          dataIndex: 'name',
        },
        {
          title: '身份证',
          dataIndex: 'card',
        },
        {
          title: '性别',
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
        },
        
        {
          title: '联系电话',
          dataIndex: 'mobile',
        },
        {
          title: '裁判等级',
          dataIndex: 'refereeLevel',
          scopedSlots: { customRender: 'refereeLevel' },
        },
        // {
        //   title: '紧急联系人',
        //   dataIndex: 'contact',
        // },
        // {
        //   title: '紧急联系人电话',
        //   dataIndex: 'contactMobile',
        // },
        // {
        //   title: '银行卡号',
        //   dataIndex: 'bankCard',
        // },
        // {
        //   title: '开户行',
        //   dataIndex: 'openingBank',
        // },
        // {
        //   title: '居住地',
        //   dataIndex: 'address',
        // },
        {
          title: '衬衫型号',
          dataIndex: 'shirtModel',
        },
        {
          title: '审核状态',
          dataIndex: 'statusCode',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '选调状态',
          dataIndex: 'isSelect',
          scopedSlots: { customRender: 'isSelect' },
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: []
    }
  },
  created() {
    window.scrollTo(0, 0)
    this.findData()
    this.findNotice()
  },
  mounted() {},
  methods: {
    findData () {
      this.$api.match.refereeSelfList({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    findNotice () {
      this.$api.join.findNoticeGetOne({matchId: this.matchId, type: 1}).then(res => {
        if (res.status === 0) {
          if (res.data !== null) {
            this.notice = res.data.html
            this.visible = true
          }
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表失败')
      })
    },
    delReferee (item) {
      this.$api.match.refereeDel({id: item.id, matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.findData()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleCancel () {
      this.visible = false
    }
  },
}
</script>
<style lang="scss" scoped>
  .page-column {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
  .content-warp {
    width: 1200px;
    margin: 0 auto;
  }
  .content-top {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/referee/Referee.vue